export default {
  fns (state) {
    state.num += 2
  },
  tage (state) {
    state.num--
  },
  bag (state) {
    state.ager += 3
  },
  tagr (state) {
    console.log(state.cordk[0].age)
  },
  dgsdg (state, val) {
    state = val
  }
}
